module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "preview"
    }
  }, [_c('h3', {
    staticClass: "title is-3"
  }, [_vm._v(_vm._s(_vm.resume.profile.name || "请填写姓名"))]), _vm._v(" "), _c('h4', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(_vm.resume.profile.title || "请输入职位"))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.resume.profile.city || "请填写城市") + "   " + _vm._s(_vm.resume.profile.birth || "请填写出生年月"))]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.filter(_vm.resume.workHistory).length > 0) ? _c('section', [_c('h3', {
    staticClass: "subtitle is-4 itemTitle"
  }, [_vm._v("工作经历")]), _vm._v(" "), _c('ul', _vm._l((_vm.filter(_vm.resume.workHistory)), function(work) {
    return _c('li', {
      staticClass: "part"
    }, [_c('p', {
      staticClass: "is-large"
    }, [_vm._v(_vm._s(work.company) + "  " + _vm._s(work.duration))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v(_vm._s(work.content))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.filter(_vm.resume.projects).length > 0) ? _c('section', [_c('h3', {
    staticClass: "subtitle is-4 itemTitle"
  }, [_vm._v("项目经历")]), _vm._v(" "), _c('ul', _vm._l((_vm.filter(_vm.resume.projects)), function(project) {
    return _c('li', [_c('p', {
      staticClass: "is-large"
    }, [_vm._v(_vm._s(project.name) + " " + _vm._s(project.duration))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(project.content))]), _vm._v(" "), _c('hr')])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.filter(_vm.resume.studyHistory).length > 0) ? _c('section', [_c('h3', {
    staticClass: "subtitle is-4 itemTitle"
  }, [_vm._v("学习经历")]), _vm._v(" "), _c('ul', _vm._l((_vm.filter(_vm.resume.studyHistory)), function(study) {
    return _c('li', [_c('p', {
      staticClass: "is-large"
    }, [_vm._v(_vm._s(study.school) + " " + _vm._s(study.duration))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(study.degree))]), _vm._v(" "), _c('hr')])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.filter(_vm.resume.awards).length > 0) ? _c('section', [_c('h3', {
    staticClass: "subtitle is-4 itemTitle"
  }, [_vm._v("获奖情况")]), _vm._v(" "), _c('ul', _vm._l((_vm.filter(_vm.resume.awards)), function(award) {
    return _c('li', [_vm._v("\n          " + _vm._s(award.name) + "\n          "), _c('hr')])
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.isEmpty(_vm.resume.contact)) ? _c('section', {
    staticClass: "contact"
  }, [_c('h3', {
    staticClass: "subtitle is-4 itemTitle"
  }, [_vm._v("联系方式")]), _vm._v(" "), _c('table', [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resume.contact.phone || "请输入电话号码"))])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resume.contact.email || "请输入邮箱"))])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resume.contact.wechat || "请输入微信"))])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.resume.contact.qq || "请输入QQ"))])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("手机号码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("电子邮箱")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("微信")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("QQ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50a8a359","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preview.vue
// module id = 193
// module chunks = 1